import { Button, Flex, Form } from 'antd';

import AddFundingAccountModal from 'components/AddFundingAccountModal/AddFundingAccountModal';
import useFundingAccounts from 'hooks/useFundingAccounts';
import useModalControls from 'hooks/useModalControls';
import { getFundingAccountName } from 'utilities/helpers';

import SelectFundingAccount from './SelectFundingAccount';

const FundingAccountPicker = ({
  form,
  formName,
  initialValues,
  fundingAccountId,
  onSelect,
  refetchQueries = ['GetCustomerFundingAccounts'],
  canAdd = true,
  label = 'Bank Account',
  name = 'fundingAccount',
  children,
}) => {
  const addFundingAccountModal = useModalControls();

  const { fundingAccounts, addNewFundingAccount } = useFundingAccounts();

  const onSelectFundingAccount = (bankAccountId) => {
    onSelect(
      bankAccountId,
      getFundingAccountName(fundingAccounts, bankAccountId),
    );
    form.setFieldsValue({ [name]: bankAccountId });
  };

  const onAddFundingAccount = (newFundingAccount) => {
    const displayName = addNewFundingAccount(newFundingAccount);
    if (!displayName) return;

    onSelect(newFundingAccount.id, displayName);
    form.setFieldsValue({ [name]: newFundingAccount.id });
  };

  return (
    <>
      <Form
        form={form}
        name={formName}
        layout="vertical"
        initialValues={initialValues}
      >
        <SelectFundingAccount
          label={label}
          name={name}
          fundingAccountId={fundingAccountId}
          fundingAccounts={fundingAccounts}
          onChange={onSelectFundingAccount}
        />
        <Flex justify="flex-end" gap="var(--spacing-sm)">
          {canAdd ? (
            <Button onClick={addFundingAccountModal.show}>
              Add New Funding Account
            </Button>
          ) : null}
          {children}
        </Flex>
      </Form>
      <AddFundingAccountModal
        {...addFundingAccountModal}
        onComplete={onAddFundingAccount}
        refetchQueries={refetchQueries}
      />
    </>
  );
};

export default FundingAccountPicker;
